export const exportToNewWindow = ({ document }) => {
  const pdfBlob = document.output("blob");  
  const pdfURL = URL.createObjectURL(pdfBlob);
  window.open(pdfURL, "_blank");
};